import React from "react";
import { Layout, Dropdown, Avatar } from "antd";
import { UserOutlined, LogoutOutlined, ProfileOutlined, BarChartOutlined, CalendarOutlined, DownOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import LogoImg from "../../Components/Assests/Images/logo.png";


export default function ReceptionistLayout({ rightContent, children }) {

    const { Header, Content } = Layout;

    const navigate = useNavigate();
    const location = useLocation();
    const roleId = sessionStorage.getItem("roleId");

    const profileMenuItems = [
        {
            key: "profile",
            label: (
                <span className="d-flex align-items-center gap-2">
                    <ProfileOutlined />
                    Profile
                </span>
            ),
        },
        {
            key: "logout",
            label: (
                <span className="d-flex align-items-center gap-2 text-danger">
                    <LogoutOutlined />
                    Logout
                </span>
            ),
        },
    ];

    const handleMenuClick = ({ key }) => {
        if (key === "profile") {
            navigate("/receptionist/profile");
        }

        if (key === "logout") {
            sessionStorage.clear();
            localStorage.clear();
        
            navigate("/");
        }
    };

    const roleMap = {
        "1": "Admin",
        "2": "Doctor",
        "3": "Receptionist",
    };

    return (
        <Layout className="min-vh-100 bg-white">
            <Header className="bg-white px-4 px-lg-8 border-bottom h-auto sticky-top" style={{ zIndex: 1000 }}>
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                    <div className="d-flex align-items-center gap-4 flex-wrap">
                        <div className="fw-bolder text-success fs-1 mb-0">
                            <img
                                src={LogoImg}
                                alt="Logo"
                                style={{
                                    height: "42px",
                                    width: "auto",
                                    maxWidth: "140px",
                                    objectFit: "contain",
                                    display: "block",
                                }}
                            />
                        </div>

                        <div
                            className="mb-0 fw-bold fs-1"
                            style={{
                                color: "#102a5c",
                                fontFamily: '"Playfair Display", "Poppins", serif',
                                letterSpacing: "0.5px",
                            }}
                        >
                            Kayathri Dental Care
                        </div>
                    </div>

                    <div className="d-flex align-items-center gap-3">
                        {rightContent}

                        <Dropdown
                            menu={{
                                items: profileMenuItems,
                                onClick: handleMenuClick,
                            }}
                            trigger={["hover", "click"]}
                            placement="bottomRight"
                        >
                            <div
                                className="d-flex align-items-center gap-2"
                                style={{ cursor: "pointer" }}
                            >
                                <div
                                    className="d-flex align-items-center justify-content-center rounded-circle bg-light-primary text-primary shadow-sm"
                                    style={{
                                        width: "42px",
                                        height: "42px",
                                    }}
                                >
                                    <Avatar size={36} icon={<UserOutlined />} />
                                </div>

                                <div className="fw-semibold text-dark">
                                    {roleMap[roleId] || "Receptionist"}
                                </div>
                            </div>
                        </Dropdown>
                    </div>
                </div>
            </Header>

            <div className="px-4 px-lg-8 py-2">
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex justify-content-end flex-grow-1">
                        <div className="d-flex gap-4 align-items-center shadow-sm px-3 py-2 rounded">
                            <div
                                className={`d-flex align-items-center gap-2 fw-semibold pb-2 ${location.pathname === "/receptionist/dashboard"
                                    ? "border-bottom border-2 border-primary text-primary"
                                    : "text-muted"
                                    }`}
                                style={{ cursor: "pointer", transition: "0.2s" }}
                                onClick={() => navigate("/receptionist/dashboard")}
                            >
                                <CalendarOutlined />
                                Appointments
                            </div>
                            {/* {roleId == "1" && (
                                <div
                                    className={`d-flex align-items-center gap-2 fw-semibold pb-2 ${location.pathname === "/admin/docotrslots"
                                        ? "border-bottom border-2 border-primary text-primary"
                                        : "text-muted"
                                        }`}
                                    style={{ cursor: "pointer", transition: "0.2s" }}
                                    onClick={() => navigate("/admin/docotrslots")}
                                >
                                    <BarChartOutlined />
                                    Slots
                                </div>
                            )} */}

                            <div
                                className={`d-flex align-items-center gap-2 fw-semibold pb-2 ${location.pathname === "/receptionist/reports"
                                    ? "border-bottom border-2 border-primary text-primary"
                                    : "text-muted"
                                    }`}
                                style={{ cursor: "pointer", transition: "0.2s" }}
                                onClick={() => navigate("/receptionist/reports")}
                            >
                                <BarChartOutlined />
                                Reports
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Content className="p-4 p-lg-8 bg-body-tertiary">
                {children}
            </Content>
        </Layout>
    );
}
